export class UpdateThreatHuntingScanRequestRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateThreatHuntingScanRequestRequest.attributeTypeMap;
    }
    constructor() {
    }
}
